interface LegacyBreakpoints {
  down: (key: keyof LegacyBreakpoints['values']) => string;
  up: (key: keyof LegacyBreakpoints['values']) => string;
  values: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
  };
}

export const legacyBreakpoints: LegacyBreakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
  },
  up: key => `@media (width >= ${legacyBreakpoints.values[key]}px)`,
  down: key => `@media (width <= ${legacyBreakpoints.values[key]}px)`
};

export const legacyBorder = '1px solid #C5C5C5';
